import React from 'react';
import { useLocation } from 'react-router-dom';

import Layout from '../Layout';
import PublicShell from '../components/common/PublicShell';
import Landing from './Landing';
import { useSessionUserId } from '../utils/session';

/**
 * The frame of every route under `/` (src/index.js): the app shell — rail,
 * context bar, palette (`Layout`) — except for ONE page, `/` itself with no
 * session, which is keepr's public landing page in the public shell (KPR-316).
 *
 * The owner's ruling (KPE-008, 2026-10-08): a signed-in visitor at `/` goes
 * straight to the app — their Home — and never sees the landing page. A
 * visitor with no session sees the landing page rather than a sign-in form;
 * the form is at `/login`, one click away in the header and the hero.
 *
 * The switch follows the SESSION (utils/session.js), not a token read once:
 * signing in on `/login` and arriving at `/` shows Home; signing out, deleting
 * the account (Profile navigates to `/`) or a token the API refuses on `/`
 * (the api client forgets it in place) shows the landing page, in place.
 *
 * The landing page is outside `Layout` so none of the shell's plumbing mounts
 * for a visitor: the shell's reads all need a session (PublicShell.js).
 *
 * The same landing page is also served WITHOUT this app: `npm run build`
 * prerenders it into build/index.html (scripts/prerender-public.mjs), and a
 * signed-out visitor at `/` reads that static page; the app loads only when
 * the page finds a session.
 */
export default function RootFrame() {
	const { pathname } = useLocation();
	const session = useSessionUserId();

	if (pathname === '/' && !session) {
		return (
			<PublicShell site>
				<Landing />
			</PublicShell>
		);
	}

	return <Layout />;
}
